import React from 'react'
import Header from './Components/Header/Header';
import Nav from './Components/Nav/Nav';
import About from './Components/About/About';
import Experience from './Components/Experience/Experience';
import Portfolio from './Components/Portfolio/Portfolio';


const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <About />
      <Experience />
      {/* <Services /> */}
      <Portfolio />
      {/* <Testimonials /> */}
      {/* <Contact />
      <Footer /> */}
    </>
  )
}

export default App;
